import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router'
import { ROUTE_COLLECTIONS } from '@klear/constants'
import { Card } from '@klear/ui/components/card'
import type { WizardStepGroupNavState } from '@klear/ui/wizard/nav-state'
import { useWizardDirtyLeaveGuard } from '@klear/ui/wizard/dirty-leave-guard'
import { Wizard } from '@klear/ui/wizard/wizard'
import { COLLECTION_TYPE_LABELS } from '@/app/collections/steps'
import { CollectionWizardLayout, useCollectionOutletContext } from '@/app/collections/outlet-context'
import { CollectionFlow } from '@/app/collections/collection-flow'
import { useDocumentTitle } from '@klear/ui/hooks/use-document-title'

function collectionHasUnsavedProgress(state: {
  selectedFees: unknown[]
  selectedRecoveries: unknown[]
  paymentDetails: unknown
}): boolean {
  return state.selectedFees.length > 0 || state.selectedRecoveries.length > 0 || state.paymentDetails != null
}

function CollectionWizardInner() {
  const navigate = useNavigate()
  const { state } = useCollectionOutletContext()
  const [nav, setNav] = useState<WizardStepGroupNavState | null>(null)
  const { LeaveConfirmDialog, guardExit } = useWizardDirtyLeaveGuard({
    when: collectionHasUnsavedProgress(state)
  })
  const guardedExit = useMemo(() => guardExit(() => navigate(`/${ROUTE_COLLECTIONS}`)), [guardExit, navigate])

  const title = state.collectionType
    ? `Collect ${COLLECTION_TYPE_LABELS[state.collectionType].toLowerCase()} payment`
    : 'Collection workflow'

  return (
    <div className="h-full min-h-0">
      {LeaveConfirmDialog}
      <Wizard
        name={title}
        steps={nav?.steps ?? []}
        activeStepId={nav?.activeStepId ?? ''}
        onStepSelect={nav?.onStepSelect}
        isStepDisabled={nav?.isStepDisabled}
        onBack={guardedExit}
        contentMaxWidthClass="max-w-6xl"
      >
        <Card className="p-6">
          <CollectionFlow onNavStateChange={setNav} />
        </Card>
      </Wizard>
    </div>
  )
}

export default function CollectionWizard() {
  useDocumentTitle('New Collection')
  return (
    <CollectionWizardLayout>
      <CollectionWizardInner />
    </CollectionWizardLayout>
  )
}
